var l = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.NUMERIC = "numeric", e.FLOATING_LABEL = "floating-label", e.WITH_ICON = "with-icon", e.FIXED_EMAIL = "fixed-email", e))(l || {});
export {
  l as InputVariant
};
//# sourceMappingURL=InputVariant.type.mjs.map
